import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import { creationEventStore } from 'state/event/eventCreationStore'
import { EventStep5Payload } from 'types/event/eventStep5'
import FaqModal from 'pages/Events/Views/Common/Modals/FaqModal'
import { EventResp } from 'types/event/events'

const FAQ: React.FC = () => {
  const [faqModalOpne, setFaqModalOpen] = useState<boolean>(false)
  const {
    eventData,
    selectedFaqIds,
    setSelectedFaqIds,
  }: {
    eventData: EventResp
    selectedFaqIds: string[]
    setSelectedFaqIds: (state: string[]) => void
  } = creationEventStore(store => ({
    eventData: store.eventData,
    selectedFaqIds: store.selectedFaqIds,
    setSelectedFaqIds: store.setSelectedFaqIds,
  }))

  return (
    <>
      <div onClick={() => setFaqModalOpen(true)}>
        <IconsTextNavigation
          iconName="Question"
          heading="FAQ"
          isCompleted={selectedFaqIds.length > 0 ? true : false}
        />
      </div>
      {faqModalOpne && (
        <FaqModal
          openModal={faqModalOpne}
          setOpenModal={setFaqModalOpen}
          organizationId={eventData.organizationId}
          referenceId={eventData._id}
          reference="event"
          selectedFaqs={selectedFaqIds}
          setSelectedFaqs={setSelectedFaqIds}
        />
      )}
    </>
  )
}

export default FAQ
